const urlBase = `${process.env.REACT_APP_API_PROTOCOL}://${
  process.env.REACT_APP_API_HOST
}${
  process.env.REACT_APP_API_PORT ? `:${process.env.REACT_APP_API_PORT}` : ""
}/api/`;

/** AUTH **/
export const urlGetLoginItemTemp = `${urlBase}v1/items/login`;

export const urlRefreshToken = `${urlBase}v1/user/refresh-token`;
export const urlLogout = `${urlBase}v1/user/logout`;
export const urlGetProfile = `${urlBase}v1/user-s/profile`;
export const urlSetNotification = `${urlBase}v1/user-s/save-subscription`;

export const urlPreRegisterEmployee = `${urlBase}v1/employeeRequest-s/preRegister`;
export const urlAccountLinksProtected = `${urlBase}v1/accountLink-s`;
export const urlAccountLinksResumeProtected = `${urlBase}v1/accountLink-s/resume`;
export const urlAccountLinksDetailsProtected = `${urlBase}v1/accountLink-s/listAccounts`;
export const urlAccountLinksDetailsExportProtected = `${urlBase}v1/accountLink-s/export`;

export const urlCompanyProtected = `${urlBase}v1/company-s`;
export const urlCaptioConceptsSecured = `${urlBase}v1/captioConcepts-s`;
export const urlExportConceptsSecured = `${urlBase}v1/captioConcepts-s/export`;

export const urlWorkingPartsProtected = `${urlBase}v1/workingPart-s`;
export const urlWorkingPartsAllProtected = `${urlBase}v1/workingPart-s/all`;
export const urlWorkingPartExportProtected = `${urlBase}v1/workingPart-s/export`;

export const urlA3Protected = `${urlBase}v1/sendA3Queue-s`;
export const urlA3multipleSecured = `${urlBase}v1/sendA3Queue-s/multiple`;
export const urlJourneyA3Protected = `${urlBase}v1/sendA3Queue-s/journeys`;
export const urlA3multipleJourneysSecured = `${urlBase}v1/sendA3Queue-s/multipleJourneys`;

export const urlEmployeeProtected = `${urlBase}v1/visualEmployee-s`;
export const urlAllEmployeeProtected = `${urlBase}v1/visualEmployee-s/all`;

export const urlConceptProtected = `${urlBase}v1/concept-s`;
export const urlAllConceptProtected = `${urlBase}v1/concept-s/all`;

export const urlParcelsProtected = `${urlBase}v1/parcel-s/all`;
